export default __webpack_public_path__ + "static/media/joinus_img_02_worldwide.457e04f8.svg";